import { render, staticRenderFns } from "./WaiverModal.vue?vue&type=template&id=2b66b390&scoped=true"
import script from "./WaiverModal.vue?vue&type=script&lang=js"
export * from "./WaiverModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b66b390",
  null
  
)

export default component.exports